import React from "react";
import PropTypes from "prop-types";
import { formatName, getInitials } from "./utils/chatUtils";

const ChatThreadItem = ({ thread, isActive, isPinned, onSelect, onPin, onArchive }) => {
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    const initialsSpan = e.target.parentElement.querySelector('span');
    if (initialsSpan) initialsSpan.style.display = 'grid';
  };

  return (
    <div
      className={`thread ${isActive ? "active" : ""}`}
      onClick={onSelect}
    >
      <div className="avatar">
        {thread.image ? (
          <img 
            src={thread.image} 
            alt={thread.name} 
            onError={handleImageError} 
          />
        ) : null}
        <span style={{ display: thread.image ? 'none' : 'grid' }}>
          {thread.initials}
        </span>
        {thread.online && <span className="dot" />}
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <strong style={{ 
          whiteSpace: "nowrap", 
          textOverflow: "ellipsis", 
          overflow: "hidden", 
          color: "#e5e7eb", 
          fontSize: 14 
        }}>
          {formatName(thread.name)}
        </strong>
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: isPinned ? "#fb7185" : "#94a3b8",
            transition: "color 0.2s ease"
          }}
          title={isPinned ? "Unpin" : "Pin"}
          onClick={(e) => {
            e.stopPropagation();
            onPin();
          }}
        >
          📌
        </span>
        {!thread.system && (
          <span
            style={{
              fontSize: 16,
              cursor: "pointer",
              color: "#94a3b8",
              transition: "color 0.2s ease"
            }}
            title="Archive"
            onClick={(e) => {
              e.stopPropagation();
              onArchive();
            }}
          >
            🗄️
          </span>
        )}
      </div>
    </div>
  );
};

ChatThreadItem.propTypes = {
  thread: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  isPinned: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onPin: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
};

ChatThreadItem.defaultProps = {
  isActive: false,
  isPinned: false,
};

export default ChatThreadItem;

